export default "__VITE_ASSET__BJmNFRod__"